import { i18n } from '@/plugins/i18n';
const { locale } = i18n;

export const calculatePercentage = (number, abs) => {
  if (number === null || number === undefined || isNaN(number)) return 0;
  const percentage = number * 100;
  return abs ? Math.abs(percentage) : percentage;
};

export const formatPercentage = (number) => {
  if (number === null || number === undefined || isNaN(number)) return '-';
  return `${calculatePercentage(number).toFixed(3)}%`;
};

export const formatPercentageShort = (number) => {
  if (number === null || number === undefined || isNaN(number)) return '-';
  return `${calculatePercentage(number).toFixed(1)}%`;
};

export const formatLocalizedNumber = (number) => {
  return number.toLocaleString(locale);
};
